'use strict';

/** @type {import('./range')} */
module.exports = RangeError;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-errors/range.js
 ** module id = 428
 ** module chunks = 0
 **/